export type ChatMessageRole = "user" | "assistant";

export type ChatMessage = {
  id: string;
  role: ChatMessageRole;
  content: string;
  uploadId?: string;
};

export type DocumentState = {
  currentInterviewProcess: boolean;
  idealCandidateProfile: boolean;
  cultureTeamContext: boolean;
  pastInterviewTranscripts: boolean;
};

export const EMPTY_DOCUMENT_STATE: DocumentState = {
  currentInterviewProcess: false,
  idealCandidateProfile: false,
  cultureTeamContext: false,
  pastInterviewTranscripts: false,
};

export function documentsProvidedCount(state: DocumentState): number {
  return [
    state.currentInterviewProcess,
    state.idealCandidateProfile,
    state.cultureTeamContext,
    state.pastInterviewTranscripts,
  ].filter(Boolean).length;
}
